import 'core-js/proposals/reflect-metadata';
import 'zone.js';
import '@angular/localize/init';